<template>
  <div class="wrapper">
    <nav :class="{ navbar: true, 'd-none': modalOpen }" :aria-hidden="modalOpen">
      <div class="navbar-brand">
        <img width="125px" src="/images/mps-logo.png" alt="mesa public schools choose mesa logo" />
        <router-link to="/schools/" class="navbar-item focus-outline-yellow"> </router-link>
        <a
          @click="toggleNavigation"
          ref="navburger"
          role="button"
          class="navbar-burger"
          aria-label="menu"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>
      <div class="navbar-menu" ref="navmenu">
        <div class="navbar-end">
          <!-- <router-link to="/schools" class="navbar-item focus-outline-yellow">
            <i class="fas fa-school"></i>
            <span>Schools</span>
          </router-link>
          <router-link exact to="/" class="navbar-item focus-outline-yellow">
            <i class="far fa-compass fa-fw"></i>
            <span>Locator</span>
          </router-link>
          <router-link to="/enrollment" class="navbar-item focus-outline-yellow">
            <i class="fas fa-user-plus"></i>
            <span>Enrollment</span>
          </router-link>
          <router-link to="/faq" class="navbar-item focus-outline-yellow">
            <i class="fas fa-question-circle"></i>
            <span>FAQ</span>
          </router-link>
          <router-link to="/features" class="navbar-item focus-outline-yellow">
            <i class="fas fa-clipboard-list"></i>
            <span>Programs</span>
          </router-link> -->
          <span class="navbar-item focus-outline-yellow">
            <i v-if="translateDropdown" @click="toggleTranslateDropdown(!translateDropdown)" class="fas fa-times-circle"></i>
            <i v-if="!translateDropdown" @click="toggleTranslateDropdown(!translateDropdown)" class="fab fa-google"></i>
            <span v-show="!translateDropdown" @click="toggleTranslateDropdown(!translateDropdown)" class="inner-translate-wrapper">
              Translate
            </span>
            <span v-show="translateDropdown" id="google_translate_element"></span>
          </span>
        </div>
      </div>
    </nav>

    <div
      :class="{ 'filters-bar-on-tablet text-right': true, 'd-none': modalOpen }"
      :aria-hidden="modalOpen"
      ref="filtersBtn"
      @click="$store.commit('toggleMobileFilters', !showMobileFilters)"
    >
      <button>
        <i class="fas fa-filter"></i>
        Filters
      </button>
    </div>

    <div
      :class="{ 'compare-bar': true, 'd-none': modalOpen }"
      :aria-hidden="modalOpen"
      ref="compare"
      @scroll="handleScroll"
      v-show="compare.keys.length > 0"
    >
      <p v-show="compare.keys.length === 1" role="alert">Select another school to compare</p>
      <button
        class="button is-small is-success focus-outline-blue"
        v-show="compare.keys.length === 2"
        @click="initCompare"
        @keyup.enter="initCompare"
        ref="compareBtn"
        aria-haspopup="true"
      >
        Compare Schools
      </button>
      <button
        class="button is-small is-danger focus-outline-blue"
        v-show="compare.keys.length === 2"
        @click="resetCompare"
        @keyup.enter="resetCompare"
      >
        Reset Compare
      </button>
    </div>

    <transition name="slide">
      <cmps-compare
        v-if="compare.active"
        @close="$store.commit('toggleCompare', false)"
      ></cmps-compare>
    </transition>

    <transition name="slide">
      <cmps-more-modal v-if="moreModal.active" :school="moreModal.school"></cmps-more-modal>
    </transition>

    <transition name="fadeIn">
      <router-view
        :class="{ 'main-content pb-5': true, 'd-none': modalOpen }"
        :aria-hidden="modalOpen"
      ></router-view>
    </transition>

    <div
      class="overlay"
      v-show="showMobileFilters"
      @click="$store.commit('toggleMobileFilters', false)"
    ></div>

    <footer :class="{ 'has-text-white': true, 'd-none': modalOpen }" :aria-hidden="modalOpen">
      <div class="footer-top">
        <div class="container py-4 px-3 d-widescreen-flex py-widescreen-5 px-widescreen-4">
          <div
            class="
              footer-brand
              text-center
              mb-5 mb-widescreen-0
              d-widescreen-flex
              align-items-widescreen-center
            "
          >
            <img
              class="pb-3 pb-widescreen-0"
              src="/images/mps-logo.png"
              alt="Mesa Public Schools logo"
            />
            <p class="font-family-montserrat is-size-5-desktop pl-widescreen-3">
              Unprecedented Excellence in Education
            </p>
          </div>
          <div
            class="
              footer-social-icons
              d-flex
              justify-content-around
              m-auto
              justify-content-widescreen-between
              flex-widescreen-grow-1
              mr-widescreen-0
            "
          >
            <div class="social-icon-circle-container">
              <a
                href="https://www.facebook.com/mpsaz/"
                target="_blank"
                aria-label="Mesa Public School Facebook page"
                class="fab fa-facebook fa-3x focus-outline-yellow"
              >
              </a>
            </div>
            <div class="social-icon-circle-container">
              <a
                href="https://twitter.com/mpsaz"
                target="_blank"
                aria-label="Mesa Public School Twitter page"
                class="fab fa-twitter fa-3x focus-outline-yellow"
              >
              </a>
            </div>
            <div class="social-icon-circle-container">
              <a
                href="https://www.instagram.com/mpsaz/"
                target="_blank"
                aria-label="Mesa Public School Instagram page"
                class="fab fa-instagram fa-3x focus-outline-yellow"
              >
              </a>
            </div>
            <div class="social-icon-circle-container">
              <a
                href="https://www.youtube.com/mpsazTV"
                target="_blank"
                aria-label="Mesa Public School Youtube channel"
                class="fab fa-youtube fa-3x focus-outline-yellow"
              >
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <div
          class="
            container
            pt-3
            pb-2
            px-3
            text-center
            d-widescreen-flex
            justify-content-widescreen-between
            p-widescreen-4
          "
        >
          <div class="footer-links mb-4 is-size-6-desktop mb-widescreen-0">
            <a
              href="http://www.mpsaz.org/accessibility/"
              target="_blank"
              class="px-2 has-text-white focus-outline-yellow"
              >accessibility</a
            >
            |
            <a
              href="http://www.mpsaz.org/parents/compliance/"
              target="_blank"
              class="px-2 has-text-white focus-outline-yellow"
              >nondiscrimination</a
            >
            |
            <router-link to="/contact" class="px-2 has-text-white focus-outline-yellow"
              >contact</router-link
            >
          </div>
          <p class="is-size-7-touch is-size-6-desktop">
            &copy; {{ new Date().getFullYear() }} Mesa Public Schools. All rights reserved
          </p>
        </div>
      </div>
    </footer>
  </div>
  <!-- end wrapper -->
</template>

<script>
import Logo from "./components/shared/Logo.vue";
import Compare from "./components/CompareModal.vue";
import MoreModal from "./components/MoreModal.vue";
import { Errors } from "@/helpers/errors.js";
import { $window } from "@/windowDimensions.js";
import { mapMutations } from 'vuex';

export default {
  components: {
    cmpsLogo: Logo,
    cmpsCompare: Compare,
    cmpsMoreModal: MoreModal,
  },
  data() {
    return {
      errors: new Errors(),
    };
  },
  computed: {
    language() {
      return this.$store.state.main.language;
    },
    translateDropdown() {
      return this.$store.state.main.translateDropdown.active;
    },
    filteredSchools() {
      return this.$store.state.main.filteredSchools;
    },
    categories() {
      return this.$store.state.search.categories;
    },
    compare() {
      return this.$store.state.main.compare;
    },
    moreModal() {
      return this.$store.state.main.moreModal;
    },
    windowWidth() {
      return $window.width;
    },
    modalOpen() {
      return this.$store.getters.modalOpen;
    },
    showMobileFilters: {
      get() {
        return this.$store.state.main.showMobileFilters;
      },
      set(value) {
        this.$store.commit("toggleMobileFilters", value);
      },
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll, { passive: true });
  },
  mounted() {
    if (this.$router.currentRoute.name !== "schools") {
      this.$refs.filtersBtn.classList.add("d-none");
    }
    if (this.$router.currentRoute.name === "locator") {
      this.$refs.compare.classList.add("locator");
    }
  },
  methods: {

    ...mapMutations([
      'toggleTranslateDropdown'
    ]),
    toggleNavigation() {
      this.$refs.navburger.classList.toggle("is-active");
      this.$refs.navmenu.classList.toggle("is-active");
    },
    handleScroll() {
      //82 is height of navbar, currently has different height on mobile 66
      if (this.$refs.compare) {
        if (window.pageYOffset > 82 && window.innerWidth >= 769 && this.compare.keys.length > 0) {
          this.$refs.compare.classList.add("sticky");
        } else if (
          window.pageYOffset > 66 &&
          window.innerWidth < 769 &&
          this.compare.keys.length > 0 &&
          this.$refs.compare
        ) {
          this.$refs.compare.classList.add("sticky");
        } else {
          this.$refs.compare.classList.remove("sticky");
        }
      }

      if (this.$refs.filtersBtn) {
        if (window.pageYOffset > 82 && window.innerWidth < 1216 && window.innerWidth >= 769) {
          this.$refs.filtersBtn.classList.add("sticky");
        } else if (window.pageYOffset > 66 && window.innerWidth < 769) {
          this.$refs.filtersBtn.classList.add("sticky");
        } else {
          this.$refs.filtersBtn.classList.remove("sticky");
        }
      }
    },
    initCompare() {
      this.$store.commit("toggleCompare", true);
      gtag("event", "init_compare", {
        event_category: "card_interaction",
        event_label: `
            ${this.compare.schools[this.compare.keys[0]].name} ${
          this.compare.schools[this.compare.keys[0]].end_name
        }
            &&
            ${this.compare.schools[this.compare.keys[1]].name} ${
          this.compare.schools[this.compare.keys[1]].end_name
        }`,
      });
    },
    resetCompare() {
      this.$store.commit("resetCompare");
    },
  },
  watch: {
    $route(to, from) {
      this.toggleNavigation(); // will toggle off bc must be open to change routes w/o page refresh

      to.name !== "schools"
        ? this.$refs.filtersBtn.classList.add("d-none")
        : this.$refs.filtersBtn.classList.remove("d-none");

      to.name === "locator"
        ? this.$refs.compare.classList.add("locator")
        : this.$refs.compare.classList.remove("locator");
    },
    "compare.keys": function (keys) {
      if (keys.length === 2) {
        setTimeout(() => this.$refs.compareBtn.focus()); // need to push this later on the stack for it to work correctly (keyboard accessibility)
      }
    },
    showMobileFilters: function (filtersOpen) {
      if (filtersOpen) {
        document.documentElement.classList.add("disable-scrolling");
        this.$refs.navburger.classList.toggle("is-active", false);
        this.$refs.navmenu.classList.toggle("is-active", false);
      } else {
        document.documentElement.classList.remove("disable-scrolling");
      }
    },
    windowWidth: function (width) {
      if (width > 1215) {
        this.$store.commit("toggleMobileFilters", false);
      }
      if (width > 1023) {
        this.$refs.navmenu.classList.remove("is-active");
        this.$refs.navburger.classList.remove("is-active");
      }
    },

  },
};
</script>

<style lang="scss">
@import "assets/main.scss";
@import "assets/_filtersToggleBar.scss";
@import "assets/_compareBar.scss";

@keyframes Fade {
  from {
    opacity: 0
  }
  to {
    opacity: 1
  }
}

@keyframes Grow {
  from {
    transform: scale(0)
               rotateY(90deg);
  }
  to {
    transform: scale(1)
               rotateY(360deg);
  }
}

.wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  // background-color: #eaeaea;
}
.main-content {
  flex-grow: 1;
  position: relative; //for the loading spinner on enrollment page
}
.overlay {
  position: fixed;
  background-color: rgba(10, 10, 10, 0.5);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 25;
}

.inner-translate-wrapper {
  color: #fff;
  animation: Grow .5s alternate ease-in-out;
  cursor: pointer;
  i {
    padding-right: 5px;
    color: #c7bdd0;
    cursor: pointer;
  }
}

#google_translate_element {
  animation: Grow .5s alternate ease-in-out !important;
}

#google_translate_element select {
  border-radius: 3px;
  background: #c7bdd09c !important;
  color: #fff !important;
  outline: yellow;
  cursor: pointer;
  max-width: 500px;
}

#google_translate_element select:focus {
  outline: yellow;
}

#goog-gt-tt,
.goog-te-balloon-frame {
  display: none !important;
}

.goog-text-highlight {
  background: none !important;
  box-shadow: none !important;
}

.goog-te-gadget {
  padding-bottom: none !important;
  font-size: .6rem !important;
  color: white !important;
}

.translate-wrapper {
  border-bottom: none !important;
  font-size: 2rem;
  min-width: 175px;
  animation: Grow .5s ease-in-out !important;
}

.translate-wrapper.navbar-item:hover {
  border-bottom: none !important;
  i:hover {
    cursor: pointer !important;
  }
}

.goog-te-gadget span:first {
  display: none !important;
}

.goog-te-gadget img,
.goog-logo-link {
  color: white !important;
}

.goog-te-menu {
  min-width: 100% !important;
}

.navbar {
  background-color: #112266;
  padding: 5px 10px;
  min-height: 85px;
  .navbar-brand {
    align-items: center;
    margin-left: 3px;
  }
  .navbar-burger {
    color: #fff;
  }
  .navbar-menu {
    background: #112266;
    &.is-active {
      border-top: 1px solid #fff;
    }
  }
  .navbar-item {
    font-size: 1.2rem;
    color: #fff;
    padding: 0;
    margin: 0.5rem 1rem;
    i {
      padding-right: 10px;
      color: #c7bdd0;
    }
    span {
      font-size: 1.2rem;
    }
  }
  .navbar-item:hover {
    background-color: transparent;
    color: #fff;
    border-bottom: 3px solid #fff;
    cursor: pointer;
  }
}
@media screen and (min-width: 1024px) {
  .navbar {
    .navbar-menu.is-active {
      border: none;
    }
    .router-link-active {
      border-bottom: 3px solid #fff;
    }
    .navbar-brand .navbar-item:hover,
    .navbar-brand .router-link-active {
      border-bottom: none;
    }
  }
}
footer {
  flex-shrink: 0;
  // img {
  //   width: 120px;
  // }
}
.footer-top {
  background-color: rgb(86, 98, 150);
}
.footer-bottom {
  background-color: #112266;
}
.footer-social-icons {
  max-width: 500px;
}
.social-icon-circle-container {
  border-radius: 50%;
  background-color: whitesmoke;
  height: 65px;
  width: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  a {
    color: #112266;
  }
}
@media screen and (min-width: 1216px) {
  .footer-social-icons {
    max-width: 400px;
  }
  .footer-links {
    order: 1;
  }
}
</style>
